export const parkingManagementCompanyStyles = {
	header: {
		backgroundColor: '#111446',
	},
	sidebar: {
		backgroundColor: '#0a0b31',
		color: 'white',
	},
	button: {
		backgroundColor: '#111446',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#21278e',
		},
	},
	title: {
		color: '#fff',
	},
	text: {
		color: '#111446',
		buttonLoadingColor: '#ffffff',
	},
	table: {
		headerBackgroundColor: '#111446',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Parking Management Company Platform',
	},
	logo: {
		small: {
			src: '/pmc/pmc-logo.png',
			height: 30,
			width: 40,
		},
		large: {
			src: '/pmc/pmc-logo.png',
			height: 44,
			width: 105,
		},
	},
	favicon: {
		src: '/pmc/pmc-logo.png',
	},
	background: {
		default: '#f9f9f9',
	},
	paper: {
		backgroundColor: '#f9f9f9',
	},
	socials: {},
	siteUrl: '',
	orgName: 'Parking Management Company',
};
